module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": _vm.profileImage,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n            " + _vm._s(_vm.name) + "\n            "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v(_vm._s(_vm.parseDate))])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v(_vm._s(_vm.latestMessage))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1323a7c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VADirectChatContact.vue
// module id = 494
// module chunks = 1